export default __webpack_public_path__ + "static/media/circular-text.1e88dce2.png";